export const processTaskList = (perfomanceData) => {
  if (!perfomanceData) {
    return [];
  }

  const planned = perfomanceData.planned_okr || {};
  const realized = perfomanceData.realized_okr || {};

  const calculateProgress = (actual, kr) => {
    return kr > 0 ? Math.round((actual / kr) * 100) : 0;
  };

  return [
    {
      icon: "EA",
      description: "Leads",
      actual: realized.lead_quantity || 0,
      kr: planned.lead_quantity || 0,
      isCurrency: false,
      progress: calculateProgress(realized.lead_quantity || 0, planned.lead_quantity || 0),
      percent: calculateProgress(realized.lead_quantity || 0, planned.lead_quantity || 0),
    },
    {
      icon: "EA",
      description: "Leads Quentes",
      actual: realized.hot_lead_quantity || 0,
      kr: planned.hot_lead_quantity || 0,
      isCurrency: false,
      progress: calculateProgress(realized.hot_lead_quantity || 0, planned.hot_lead_quantity || 0),
      percent: calculateProgress(realized.hot_lead_quantity || 0, planned.hot_lead_quantity || 0),
    },
    {
      icon: "EE",
      description: "Entrevistas Agendadas",
      actual: realized.ea_quantity || 0,
      kr: planned.ea_quantity || 0,
      isCurrency: false,
      progress: calculateProgress(realized.ea_quantity || 0, planned.ea_quantity || 0),
      percent: calculateProgress(realized.ea_quantity || 0, planned.ea_quantity || 0),
    },
    {
      icon: "EE",
      description: "Entrevistas Feitas",
      actual: realized.ef_quantity || 0,
      kr: planned.ef_quantity || 0,
      isCurrency: false,
      progress: calculateProgress(realized.ef_quantity || 0, planned.ef_quantity || 0),
      percent: calculateProgress(realized.ef_quantity || 0, planned.ef_quantity || 0),
    },
    {
      icon: "EP",
      description: "Entrevistas Pagas",
      actual: realized.ep_quantity || 0,
      kr: planned.ep_quantity || 0,
      isCurrency: false,
      progress: calculateProgress(realized.ep_quantity || 0, planned.ep_quantity || 0),
      percent: calculateProgress(realized.ep_quantity || 0, planned.ep_quantity || 0),
    },
    {
      icon: "FEP",
      description: "Faturamento EP (R$)",
      actual: realized.ep_amount || 0,
      kr: planned.ep_amount || 0,
      isCurrency: true,
      progress: calculateProgress(realized.ep_amount || 0, planned.ep_amount || 0),
      percent: calculateProgress(realized.ep_amount || 0, planned.ep_amount || 0),
    },
    {
      icon: "MXA",
      description: "Momento X Agendado",
      actual: realized.mxa_quantity || 0,
      kr: planned.mxa_quantity || 0,
      isCurrency: false,
      progress: calculateProgress(realized.mxa_quantity || 0, planned.mxa_quantity || 0),
      percent: calculateProgress(realized.mxa_quantity || 0, planned.mxa_quantity || 0),
    },
    {
      icon: "PA",
      description: "Parceria Agendada",
      actual: realized.pa_quantity || 0,
      kr: planned.pa_quantity || 0,
      isCurrency: false,
      progress: calculateProgress(realized.pa_quantity || 0, planned.pa_quantity || 0),
      percent: calculateProgress(realized.pa_quantity || 0, planned.pa_quantity || 0),
    },
    {
      icon: "AS",
      description: "Assinatura (R$)",
      actual: realized.subscriptions_amount || 0,
      kr: planned.subscriptions_amount || 0,
      isCurrency: true,
      progress: calculateProgress(realized.subscriptions_amount || 0, planned.subscriptions_amount || 0),
      percent: calculateProgress(realized.subscriptions_amount || 0, planned.subscriptions_amount || 0),
    },
    {
      icon: "SL",
      description: "Solução (R$)",
      actual: realized.financial_solutions_amount || 0,
      kr: planned.financial_solutions_amount || 0,
      isCurrency: true,
      progress: calculateProgress(realized.financial_solutions_amount || 0, planned.financial_solutions_amount || 0),
      percent: calculateProgress(realized.financial_solutions_amount || 0, planned.financial_solutions_amount || 0),
    },
    {
      icon: "OKR",
      description: "OKR total",
      actual: realized.total_amount || 0,
      kr: planned.total_amount || 0,
      isCurrency: true,
      progress: calculateProgress(realized.total_amount || 0, planned.total_amount || 0),
      percent: calculateProgress(realized.total_amount || 0, planned.total_amount || 0),
    },
  ];
}